import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Minus } from "lucide-react";
import { useLang } from "@/i18n";
import PageSeo from "@/components/PageSeo";
import JsonLd from "@/components/JsonLd";
import SeoFooter from "@/components/SeoFooter";
import { FAQ_PAGE, ORIGIN } from "@/data/seoPages";

const GOLD = "#C7A668";

export default function FaqPage({ lang: routeLang }) {
  const ctx = useLang();
  const lang = routeLang || ctx.lang;
  const L = (en, es) => (lang === "en" ? en : es);
  const c = FAQ_PAGE[lang];
  const li = lang === "en" ? 0 : 1;
  const [open, setOpen] = useState(0);
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const canonical = ORIGIN + (lang === "en" ? FAQ_PAGE.enPath : FAQ_PAGE.esPath);

  const jsonld = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    url: canonical,
    mainEntity: FAQ_PAGE.items.map((it) => ({
      "@type": "Question",
      name: it.q[li],
      acceptedAnswer: { "@type": "Answer", text: it.a[li] },
    })),
  };

  return (
    <div className="grain" style={{ minHeight: "100vh", paddingTop: 110 }}>
      <PageSeo esPath={FAQ_PAGE.esPath} enPath={FAQ_PAGE.enPath} title={c.title} description={c.desc} lang={lang} image={`${ORIGIN}/og/faq-${lang}.png`} />
      <JsonLd data={jsonld} id="jsonld-faq" />
      <article data-testid="faq-page" style={{ maxWidth: 800, margin: "0 auto", padding: "0 clamp(20px,5vw,40px)" }}>
        <div className="font-mono" style={{ fontSize: 10.5, letterSpacing: ".18em", color: GOLD, marginBottom: 14 }}>{c.kicker.toUpperCase()}</div>
        <h1 style={{ fontSize: "clamp(30px,5vw,52px)", fontWeight: 400, margin: 0, letterSpacing: "-.02em" }}>{c.h1}</h1>

        <div style={{ marginTop: 36, borderTop: "1px solid rgba(255,255,255,.1)" }}>
          {FAQ_PAGE.items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`} style={{ borderBottom: "1px solid rgba(255,255,255,.1)" }}>
                <button onClick={() => setOpen(isOpen ? -1 : i)} data-testid={`faq-toggle-${i}`} style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, padding: "22px 0", background: "none", border: "none", cursor: "pointer", textAlign: "left" }}>
                  <h2 style={{ fontSize: "clamp(16px,2.2vw,20px)", fontWeight: 400, margin: 0, color: "#E7E4DD", letterSpacing: "-.01em" }}>{it.q[li]}</h2>
                  {isOpen ? <Minus size={18} color={GOLD} style={{ flexShrink: 0 }} /> : <Plus size={18} color="#7a808a" style={{ flexShrink: 0 }} />}
                </button>
                {isOpen && <p style={{ fontSize: 15.5, color: "#B8BDC3", lineHeight: 1.7, margin: "0 0 24px", maxWidth: 680 }}>{it.a[li]}</p>}
              </div>
            );
          })}
        </div>

        <div style={{ marginTop: 44, display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Link to={lang === "en" ? "/en/book" : "/book"} data-testid="faq-cta-book" className="tb-cta" style={{ background: "#F2EFE8", color: "#0a0a0a", fontWeight: 600, borderRadius: 4, padding: "12px 22px", fontSize: 14, textDecoration: "none" }}>{L("Book service", "Reservar servicio")}</Link>
          <Link to={lang === "en" ? "/en/about-dukk" : "/sobre-dukk"} style={{ color: GOLD, border: `1px solid ${GOLD}`, borderRadius: 4, padding: "12px 22px", fontSize: 14, textDecoration: "none" }}>{L("About dukk", "Sobre dukk")}</Link>
        </div>
      </article>
      <SeoFooter />
    </div>
  );
}
